/*
 * @Description: 底部栏接口
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-18 21:37:11
 * @LastEditTime: 2019-07-24 14:13:08
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

// 底部栏
export const getData = params => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/bottom`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findBottomInfo'
      }, params))
    }
  })
}
